import { render, staticRenderFns } from "./PainelTotaisPedidos.vue?vue&type=template&id=1fc971d0"
import script from "./PainelTotaisPedidos.vue?vue&type=script&lang=js"
export * from "./PainelTotaisPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports